import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const MenuToggleButton = ({ onClick, className = '', title = 'Afficher/masquer le menu' }) => {
  return (
    <button className={`menu-btn-inline ${className}`} onClick={onClick} title={title}>
      <FontAwesomeIcon icon={faBars} />
    </button>
  );
};

export default MenuToggleButton;